import React, { ComponentProps, useContext } from 'react'

import { GuildIcon } from './GuildIcon/GuildIcon'
import { TokensContext } from './context'
import { Element } from './Element'

export type IconName = ComponentProps<typeof GuildIcon>['name']
type IconProps = {
  name: IconName
  size?: number
  testID?: string
  variant?: string
}

export const Icon = ({ name, size = 5, testID, variant }: IconProps) => {
  const tokensContext = useContext(TokensContext)

  const tokenSize = (() => {
    const sizeValue = tokensContext.size
    if (sizeValue === undefined) return size
    if (typeof sizeValue === 'number') return sizeValue
    return sizeValue[size] ?? size
  })()

  return (
    // @ts-expect-error - GuildIcon has required props that Element's as prop doesn't account for
    <Element
      component='Icon'
      variant={variant}
      as={GuildIcon}
      name={name}
      size={tokenSize}
      tokens={{ width: size, height: size, minWidth: size, minHeight: size }}
      testID={testID}
    />
  )
}
